import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from 'interfaces/httpClient';
import { ComplaintDocument } from '@/interfaces/complaint';
import { CaseType } from '@/interfaces';

class ComplaintService {
	constructor(private client: AxiosInstance) {}

	async getComplaintDocuments(
		case_id: string,
		type_complaint: CaseType
	): Promise<HttpResponse<ComplaintDocument[]>> {
		return this.client.get(
			`/complaint?case_id=${case_id}&type_complaint=${type_complaint}`
		);
	}

	async getComplaint(
		case_id: string,
		type_complaint: CaseType,
		is_all_users: boolean
	): Promise<HttpResponse<ComplaintDocument[]>> {
		return this.client.get(
			`/complaint?case_id=${case_id}&type_complaint=${type_complaint}&is_all_users=${is_all_users}`
		);
	}

	async getComplaintVersion(
		version_id: string
	): Promise<HttpResponse<ComplaintDocument[]>> {
		return this.client.get(`/complaint/version/${version_id}`);
	}

	async getComplaintUserCounts(
		case_id: string,
		case_type: CaseType
	): Promise<HttpResponse<{ totalUsers: number; newUsers: number }>> {
		return this.client.get(
			`/complaint/counts/${case_id}?caseType=${case_type}`
		);
	}
}

export const complaintService = new ComplaintService(axiosClient);
